import { useApp } from "../context";
import { Heading, Table, Badge } from "../components/Bits";
import { money } from "../lib/engine";

const AuditTable = () => {
  const { state, actions } = useApp();
  return (
    <div className="card space">
      <div className="heading" style={{ marginBottom: 10 }}>
        <div>
          <h2 style={{ margin: 0 }}>Demo audit history</h2>
          <small className="muted">Showing latest 30 of {state.audit.length}. Export includes all entries.</small>
        </div>
        <button data-testid="export-audit-btn" onClick={() => actions.exportAudit(state)}>Export audit CSV</button>
      </div>
      <Table testId="audit-table" headers={["Time", "Actor", "Action", "Case / tranche"]}>
        {state.audit.slice(0, 30).map((a, i) => (
          <tr key={a.time + i}>
            <td>{new Date(a.time).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
            <td>{a.actor}</td>
            <td>{a.action}</td>
            <td>{a.caseId}<small>{a.disb}</small></td>
          </tr>
        ))}
      </Table>
    </div>
  );
};

export default function Exceptions() {
  const { state, openModal } = useApp();
  return (
    <>
      <Heading title="Exceptions" description="Assign ownership, follow-up dates and resolution notes." />
      <div className="notice">
        Delayed collections and blocked attempts are not classified as losses.
        Collection exceptions resolve when the outstanding bank receipt is matched.
      </div>
      <div className="card">
        <Table testId="exceptions-table" headers={["Exception / case", "Amount at issue", "Owner / due", "Status", "Action"]}>
          {state.exceptions.map(e => (
            <tr key={e.id} data-testid={`exception-row-${e.id}`}>
              <td>
                <strong>{e.type}</strong>
                <small>{e.caseId} · {e.disb}</small>
                <small>{e.note}</small>
              </td>
              <td className="number">{money(e.amount)}</td>
              <td>{e.owner}<small>{e.due}</small></td>
              <td><Badge text={e.status} testId={`exception-status-${e.id}`} /></td>
              <td>
                <button data-testid={`manage-exception-btn-${e.id}`}
                  onClick={() => openModal({ type: "exception", id: e.id })}>Manage</button>
              </td>
            </tr>
          ))}
        </Table>
      </div>
      <AuditTable />
    </>
  );
}
